import React from "react";
import "./inline.scss";

export default function InlineLoading({ text = "Loading..." }) {
  return (
    <div className="inline-flex relative">
      <div className="inline-loading__spin"></div>
      <div className="inline-loading__text ml-6">{text}</div>
    </div>
  );
}
